import React from 'react';
import { t } from '../../helpers/componentHelper';

import './About.scss';

// top level About page component, isolated from routing logic
function About() {
  return (
    <div className="about">
      <div className="about__header">
        <div>{`${t('pages.about.header')}`}</div>
        <div className={'about__header--subtext'}>{`${t('pages.about.headerSubtext')}`}</div>
      </div>
      <div className="about__info">
        <p>
          {`${t('pages.about.prePre')}`}
          <b>you</b>
          {`${t('pages.about.pre')}`}
        </p>
        <p>
          {`${t('pages.about.info')}`}
          <span className={'about__info--tm'}>
            <span>Lock Platform</span>;
          </span>
          {`${t('pages.about.infoPartOne')}`}
        </p>
        <div className={'about__info--tm'}>
          {'A'}
          <span>LOCK PICK &#8482;</span>
          {` ${t('pages.about.infoPartTwo')}`}
          <span className={'about__info--tm'}>Lock Platform</span>.
        </div>
        <p>{`${t('pages.about.infoPartThree')}`}</p>
      </div>
      <div className="about__footer">{`${t('app.gettingStarted')}`}</div>
      <p className={'about__info--disclosure'}>{`${t('pages.about.infoPartFour')}`}</p>
    </div>
  );
}

export default About;
